// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4873":"7e214387bc3d703b","6461":"a7e286abb385863d","9945":"6c4930e1a69beeb6"}[chunkId] + ".js";
};